<div class="download-progress">
  @if (data?.progress$?.value?.finished && data?.progress$?.value?.failed === false) {
    <div class="progress-wrapper done-wrapper">
      <div class="done-wrapper-content">
        <eop-icon
          class="done-icon"
          [identifier]="'check-circle-filled'"
          [vaylensFont]="true"></eop-icon>
        <div class="progress-text sub-heading-m">{{ 'GLOBAL.DONE' | translate }}</div>
      </div>
      <button
        eopButton
        [leftIcon]="'document-download-outlined'"
        [color]="ButtonColor.SECONDARY"
        [size]="ButtonSize.MEDIUM"
        class="download-button"
        (click)="downloadButtonClicked()">
        {{ data?.progress$?.value?.downloadButtonText }}
      </button>
    </div>
  } @else if (data?.progress$?.value?.finished && data?.progress$?.value?.failed === true) {
    <div class="progress-wrapper done-wrapper">
      <div class="done-wrapper-content">
        <eop-icon
          class="fail-icon"
          [identifier]="'close-circle-filled'"
          [vaylensFont]="true"></eop-icon>
        <div class="progress-text sub-heading-m">
          {{ 'BASIC_PROFILE.UPLOAD_STATUS_FAILED' | translate }}
        </div>
      </div>
    </div>
  } @else {
    <div class="progress-wrapper" (click)="openPacman()">
      <div class="progress-text sub-heading-m">{{ data?.progress$?.value?.progressText }}</div>
      <div class="progress-percentage body-m">({{ data?.progress$?.value?.progress }}%)</div>
    </div>
  }
  <eop-icon
    [identifier]="'close-outlined'"
    [vaylensFont]="true"
    [color]="IconColor.NORMAL"
    [clickable]="true"
    (click)="closeSnackbar()"></eop-icon>
</div>
